import { createContext, useContext } from "react";

export const AppPortalContext = createContext<HTMLElement | null>(null);

export function useAppPortalContainer(): HTMLElement | null {
    return useContext(AppPortalContext);
}
